module.exports = __webpack_public_path__ + "static/media/parayas_bannerlogo.3fd7cd03.png";